export default (html) => {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    return parsed.documentElement.textContent;
}
